import { render, staticRenderFns } from "./CollapseButton.vue?vue&type=template&id=7dc0041c&"
import script from "./CollapseButton.vue?vue&type=script&lang=js&"
export * from "./CollapseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports